// export default 'development'
// export default 'test'
export default 'production'



// WEBPACK FOOTER //
// ./src/config/env.js